/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BillingDocument } from '../models/billing-document';
import { completeInvoiceDocumentWithoutPo } from '../fn/invoice-document/complete-invoice-document-without-po';
import { CompleteInvoiceDocumentWithoutPo$Params } from '../fn/invoice-document/complete-invoice-document-without-po';
import { dismissInvoiceDocument } from '../fn/invoice-document/dismiss-invoice-document';
import { DismissInvoiceDocument$Params } from '../fn/invoice-document/dismiss-invoice-document';
import { exportInvoiceDocuments } from '../fn/invoice-document/export-invoice-documents';
import { ExportInvoiceDocuments$Params } from '../fn/invoice-document/export-invoice-documents';
import { getInvoiceDocument } from '../fn/invoice-document/get-invoice-document';
import { GetInvoiceDocument$Params } from '../fn/invoice-document/get-invoice-document';
import { getInvoiceDocumentFile } from '../fn/invoice-document/get-invoice-document-file';
import { GetInvoiceDocumentFile$Params } from '../fn/invoice-document/get-invoice-document-file';
import { InvoiceDocument } from '../models/invoice-document';
import { InvoiceDocumentFile } from '../models/invoice-document-file';
import { InvoiceDocumentSearchResult } from '../models/invoice-document-search-result';
import { linkInvoiceDocument } from '../fn/invoice-document/link-invoice-document';
import { LinkInvoiceDocument$Params } from '../fn/invoice-document/link-invoice-document';
import { listInvoiceDocumentFiles } from '../fn/invoice-document/list-invoice-document-files';
import { ListInvoiceDocumentFiles$Params } from '../fn/invoice-document/list-invoice-document-files';
import { patchInvoiceDocumentServiceValidation } from '../fn/invoice-document/patch-invoice-document-service-validation';
import { PatchInvoiceDocumentServiceValidation$Params } from '../fn/invoice-document/patch-invoice-document-service-validation';
import { searchInvoiceDocuments } from '../fn/invoice-document/search-invoice-documents';
import { SearchInvoiceDocuments$Params } from '../fn/invoice-document/search-invoice-documents';
import { selectInvoiceDocumentService } from '../fn/invoice-document/select-invoice-document-service';
import { SelectInvoiceDocumentService$Params } from '../fn/invoice-document/select-invoice-document-service';
import { syncInvoiceDocument } from '../fn/invoice-document/sync-invoice-document';
import { SyncInvoiceDocument$Params } from '../fn/invoice-document/sync-invoice-document';
import { unlinkInvoiceDocument } from '../fn/invoice-document/unlink-invoice-document';
import { UnlinkInvoiceDocument$Params } from '../fn/invoice-document/unlink-invoice-document';

@Injectable({ providedIn: 'root' })
export class InvoiceDocumentApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getInvoiceDocument()` */
  static readonly GetInvoiceDocumentPath = '/invoice-document/{uuid}';

  /**
   * Get an invoice document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoiceDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceDocument$Response(params: GetInvoiceDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocument>> {
    const obs = getInvoiceDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get an invoice document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInvoiceDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceDocument(params: GetInvoiceDocument$Params, context?: HttpContext): Observable<InvoiceDocument> {
    const resp = this.getInvoiceDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InvoiceDocument>): InvoiceDocument => r.body)
    );
  }

  /** Path part for operation `selectInvoiceDocumentService()` */
  static readonly SelectInvoiceDocumentServicePath = '/invoice-document/{uuid}/service';

  /**
   * Select service for invoice document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selectInvoiceDocumentService()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selectInvoiceDocumentService$Response(params: SelectInvoiceDocumentService$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocument>> {
    const obs = selectInvoiceDocumentService(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Select service for invoice document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selectInvoiceDocumentService$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selectInvoiceDocumentService(params: SelectInvoiceDocumentService$Params, context?: HttpContext): Observable<InvoiceDocument> {
    const resp = this.selectInvoiceDocumentService$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InvoiceDocument>): InvoiceDocument => r.body)
    );
  }

  /** Path part for operation `patchInvoiceDocumentServiceValidation()` */
  static readonly PatchInvoiceDocumentServiceValidationPath = '/invoice-document/{uuid}/service-validation';

  /**
   * Service validation of an Invoice Document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchInvoiceDocumentServiceValidation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchInvoiceDocumentServiceValidation$Response(params: PatchInvoiceDocumentServiceValidation$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocument>> {
    const obs = patchInvoiceDocumentServiceValidation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Service validation of an Invoice Document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchInvoiceDocumentServiceValidation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchInvoiceDocumentServiceValidation(params: PatchInvoiceDocumentServiceValidation$Params, context?: HttpContext): Observable<InvoiceDocument> {
    const resp = this.patchInvoiceDocumentServiceValidation$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InvoiceDocument>): InvoiceDocument => r.body)
    );
  }

  /** Path part for operation `dismissInvoiceDocument()` */
  static readonly DismissInvoiceDocumentPath = '/invoice-document/{uuid}/dismiss';

  /**
   * Dismiss an Invoice Document.
   *
   * Dismisses an invoice document. If no billing document exists yet, one is created automatically and marked as dismissed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dismissInvoiceDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dismissInvoiceDocument$Response(params: DismissInvoiceDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocument>> {
    const obs = dismissInvoiceDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Dismiss an Invoice Document.
   *
   * Dismisses an invoice document. If no billing document exists yet, one is created automatically and marked as dismissed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dismissInvoiceDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dismissInvoiceDocument(params: DismissInvoiceDocument$Params, context?: HttpContext): Observable<InvoiceDocument> {
    const resp = this.dismissInvoiceDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InvoiceDocument>): InvoiceDocument => r.body)
    );
  }

  /** Path part for operation `completeInvoiceDocumentWithoutPo()` */
  static readonly CompleteInvoiceDocumentWithoutPoPath = '/invoice-document/{uuid}/complete';

  /**
   * Complete the invoice document and create a new invoice.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `completeInvoiceDocumentWithoutPo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completeInvoiceDocumentWithoutPo$Response(params: CompleteInvoiceDocumentWithoutPo$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocument>> {
    const obs = completeInvoiceDocumentWithoutPo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Complete the invoice document and create a new invoice.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `completeInvoiceDocumentWithoutPo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completeInvoiceDocumentWithoutPo(params: CompleteInvoiceDocumentWithoutPo$Params, context?: HttpContext): Observable<InvoiceDocument> {
    const resp = this.completeInvoiceDocumentWithoutPo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InvoiceDocument>): InvoiceDocument => r.body)
    );
  }

  /** Path part for operation `listInvoiceDocumentFiles()` */
  static readonly ListInvoiceDocumentFilesPath = '/invoice-document/{uuid}/files';

  /**
   * List files associated with an invoice document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInvoiceDocumentFiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoiceDocumentFiles$Response(params: ListInvoiceDocumentFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InvoiceDocumentFile>>> {
    const obs = listInvoiceDocumentFiles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List files associated with an invoice document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listInvoiceDocumentFiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoiceDocumentFiles(params: ListInvoiceDocumentFiles$Params, context?: HttpContext): Observable<Array<InvoiceDocumentFile>> {
    const resp = this.listInvoiceDocumentFiles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<InvoiceDocumentFile>>): Array<InvoiceDocumentFile> => r.body)
    );
  }

  /** Path part for operation `getInvoiceDocumentFile()` */
  static readonly GetInvoiceDocumentFilePath = '/invoice-document/{uuid}/file';

  /**
   * Retrieve a file associated with an invoice document.
   *
   * Returns a file (PDF, UBL, or other) attached to the specified invoice document.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoiceDocumentFile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getInvoiceDocumentFile$Response(params: GetInvoiceDocumentFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = getInvoiceDocumentFile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a file associated with an invoice document.
   *
   * Returns a file (PDF, UBL, or other) attached to the specified invoice document.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInvoiceDocumentFile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getInvoiceDocumentFile(params: GetInvoiceDocumentFile$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.getInvoiceDocumentFile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `linkInvoiceDocument()` */
  static readonly LinkInvoiceDocumentPath = '/invoice-document/{uuid}/link';

  /**
   * Link an invoice document to a purchase order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `linkInvoiceDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  linkInvoiceDocument$Response(params: LinkInvoiceDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<BillingDocument>> {
    const obs = linkInvoiceDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Link an invoice document to a purchase order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `linkInvoiceDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  linkInvoiceDocument(params: LinkInvoiceDocument$Params, context?: HttpContext): Observable<BillingDocument> {
    const resp = this.linkInvoiceDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BillingDocument>): BillingDocument => r.body)
    );
  }

  /** Path part for operation `unlinkInvoiceDocument()` */
  static readonly UnlinkInvoiceDocumentPath = '/invoice-document/{uuid}/unlink';

  /**
   * Unlink an invoice document from its purchase order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unlinkInvoiceDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  unlinkInvoiceDocument$Response(params: UnlinkInvoiceDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocument>> {
    const obs = unlinkInvoiceDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Unlink an invoice document from its purchase order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unlinkInvoiceDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unlinkInvoiceDocument(params: UnlinkInvoiceDocument$Params, context?: HttpContext): Observable<InvoiceDocument> {
    const resp = this.unlinkInvoiceDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InvoiceDocument>): InvoiceDocument => r.body)
    );
  }

  /** Path part for operation `syncInvoiceDocument()` */
  static readonly SyncInvoiceDocumentPath = '/invoice-document/{uuid}/sync';

  /**
   * Retry matching missing related entities (supplier, delivery address ...) for an invoice document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `syncInvoiceDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncInvoiceDocument$Response(params: SyncInvoiceDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocument>> {
    const obs = syncInvoiceDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retry matching missing related entities (supplier, delivery address ...) for an invoice document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `syncInvoiceDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncInvoiceDocument(params: SyncInvoiceDocument$Params, context?: HttpContext): Observable<InvoiceDocument> {
    const resp = this.syncInvoiceDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InvoiceDocument>): InvoiceDocument => r.body)
    );
  }

  /** Path part for operation `searchInvoiceDocuments()` */
  static readonly SearchInvoiceDocumentsPath = '/invoice-document/search';

  /**
   * Search invoice documents based on criteria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchInvoiceDocuments()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchInvoiceDocuments$Response(params: SearchInvoiceDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocumentSearchResult>> {
    const obs = searchInvoiceDocuments(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search invoice documents based on criteria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchInvoiceDocuments$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchInvoiceDocuments(params: SearchInvoiceDocuments$Params, context?: HttpContext): Observable<InvoiceDocumentSearchResult> {
    const resp = this.searchInvoiceDocuments$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<InvoiceDocumentSearchResult>): InvoiceDocumentSearchResult => r.body)
    );
  }

  /** Path part for operation `exportInvoiceDocuments()` */
  static readonly ExportInvoiceDocumentsPath = '/invoice-document/export';

  /**
   * Export invoice documents based on criteria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportInvoiceDocuments()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportInvoiceDocuments$Response(params: ExportInvoiceDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = exportInvoiceDocuments(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Export invoice documents based on criteria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportInvoiceDocuments$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportInvoiceDocuments(params: ExportInvoiceDocuments$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.exportInvoiceDocuments$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
